import type { TRPC } from './types';
import type { SearchScope } from '@/lib/enums/searchScope';

export const searchKeys = {
  more: (trpc: TRPC) => trpc.search.more.pathKey(),
};

type SearchMoreArgs = {
  trpc: TRPC;
  query?: string;
  scope: SearchScope;
  from: number;
  limit: number;
};

export const searchMoreQueryOptions = ({ trpc, query, scope, from, limit }: SearchMoreArgs) =>
  trpc.search.more.queryOptions(
    { query, scope, from, limit },
    {
      staleTime: 0,
    },
  );
